import { FC, useState, useEffect } from "react"
import Card from "@mui/material/Card"
import Icon from "@mui/material/Icon"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { Checkbox, FormControlLabel } from "@mui/material"
import { manageMedicalRecordUpdateStopMail } from "../../../../api/manage_medical_record_update_stop_mail"
import { useNavigate } from "react-router-dom"
import { useLoading } from "../../../LoadingContext"

interface ResidentCardProps {
  icon: string
  color: "primary" | "success" | "info" | "warning" | "dark"
  title: string
  roomNumber: string
  lastDetectionAt: string
  id: string
  stop_mail: number
  onClick?: () => void
}

const ResidentCard: FC<ResidentCardProps> = ({
  icon,
  color,
  title,
  roomNumber,
  lastDetectionAt,
  id,
  stop_mail,
  onClick
}) => {
  const { startLoading, stopLoading } = useLoading()
  const navigate = useNavigate()
  const [stopMail, setStopMail] = useState<number>(0)
  const isSuccess = color === "success"
  const account_type = localStorage.getItem("account_type")

  useEffect(() => {
    if (stop_mail !== undefined) setStopMail(stop_mail)
  }, [])

  const changeStopMail = async (event: React.MouseEvent) => {
    event.stopPropagation()

    const target = event.target as HTMLElement
    if (target.tagName === "INPUT" || target.closest(".MuiCheckbox-root")) {
      //update_stop_mail へ通信を行う
      try {
        startLoading()
        //通信処理
        await manageMedicalRecordUpdateStopMail(id, stopMail === 1 ? 0 : 1)
        //UIを更新
        setStopMail((prev) => (prev === 1 ? 0 : 1))
      } catch (error: any) {
        // セッション切れ時にトップページへリダイレクト
        //console.log(error)
        navigate("/login")
      } finally {
        stopLoading()
      }
    }
  }

  return (
    <Card
      sx={{
        cursor: onClick ? "pointer" : "default", // onClick がない場合はデフォルトのカーソル
        pointerEvents: onClick ? "auto" : "none", // onClick が undefined なら hover を無効化
        transition: "all 0.2s ease-in-out",
        "&:hover": onClick
          ? {
              transform: "translateY(-4px)",
              boxShadow: "0 10px 20px rgba(0,0,0,0.1)"
            }
          : {}, // onClick がない場合は hover のスタイルを適用しない
        display: "flex !important",
        flexDirection: "row !important",
        overflow: "hidden",
        height: "100%"
      }}
      onClick={onClick}
    >
      <MDBox
        width="30%"
        height="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgColor={isSuccess ? "white" : color}
        variant={isSuccess ? "contained" : "gradient"}
      >
        <Icon
          sx={{
            color: isSuccess ? `${color}.main` : "white !important",
            fontSize: "2.5rem !important"
          }}
        >
          {icon}
        </Icon>
      </MDBox>
      <MDBox p={2} width="70%">
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          {title}
        </MDTypography>
        <MDTypography variant="caption" color="text" fontWeight="regular">
          部屋番号: {roomNumber}
        </MDTypography>
        <MDTypography variant="caption" color="text" fontWeight="regular" display="block">
          更新日時: {lastDetectionAt}
        </MDTypography>
        <MDBox display="flex" alignItems="center" gap={1} onClick={changeStopMail}>
          <FormControlLabel
            control={<Checkbox defaultChecked checked={stopMail == 0} />}
            label={stopMail == 0 ? "通知ON" : "通知OFF"}
            sx={{ color: stopMail == 0 ? "#000000" : "#ff0000" }}
            className="stop-mail-checkbox"
            disabled={account_type === "estate" ? false : true}
          />
        </MDBox>
      </MDBox>
    </Card>
  )
}

export default ResidentCard
